import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
	transform(array, orderBy, asc = true) {
		if (!array) {
			return;
		}
		if (!orderBy || orderBy.trim() === '') {
			return array;
		}

		if (asc) {
			return Array.from(array).sort((item1: any, item2: any) => {
				return this.orderByComparator(item1[orderBy], item2[orderBy]);
			});
		} else {
			return Array.from(array).sort((item1: any, item2: any) => {
				return this.orderByComparator(item2[orderBy], item1[orderBy]);
			});
		}
	}

	orderByComparator(a: any, b: any): number {
		if (a === null || b === null) {
			return 1;
		}

		if (isNaN(parseFloat(a)) || !isFinite(a) || isNaN(parseFloat(b)) || !isFinite(b)) {
			return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
		} else {
			return parseFloat(a) < parseFloat(b) ? -1 : 1;
		}
	}
}
